import { createFileRoute } from "@tanstack/react-router";

import { BookOrderForm } from "@/components/forms/BookOrderForm";
import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";
import { PageHero } from "@/components/layout/PageHero";
import { heroFor } from "@/data/heroes";
import { pageBlocks } from "@/lib/content";

const TITLE = "Fire Carriers — Light of Life International";
const DESCRIPTION =
  "Fire Carriers by Stephen Evans: what happens when average people dare to dream with an extraordinary God? Order your copy.";

export const Route = createFileRoute("/fire-carriers")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "book" },
      { property: "og:url", content: "https://loli.ardent.dev/fire-carriers" },
    ],
    links: [{ rel: "canonical", href: "https://loli.ardent.dev/fire-carriers" }],
  }),
  component: FireCarriersPage,
});

function FireCarriersPage() {
  const blocks = pageBlocks("fire-carriers");
  const text = (i: number) => {
    const block = blocks[i];
    return block && "text" in block ? block.text : "";
  };

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <Header overlay />

      <main id="main" className="flex-1">
        <PageHero
          title={text(0) || "Fire Carriers"}
          image={heroFor("/fire-carriers").image}
          subtitle={text(1)}
          attribution={text(2)}
        />

        {/* Endorsements + book */}
        <section className="container-site section-y grid gap-12 md:grid-cols-[1fr_18rem]">
          <div>
            <h2 className="text-4xl text-muted-foreground sm:text-5xl">{text(3)}</h2>
            <p className="mt-4 font-heading text-2xl uppercase text-muted-foreground">{text(4)}</p>
            <div className="mt-8 space-y-8">
              <blockquote className="text-foreground">{text(5)}</blockquote>
              <blockquote className="text-foreground">{text(6)}</blockquote>
            </div>
          </div>
          <div className="flex flex-col items-center gap-8">
            <img
              src="/media/FC_transparent_3D_large-218x300-1.webp"
              alt="Fire Carriers book by Stephen Evans"
              className="w-56"
            />
            <a
              href="#grab-a-copy"
              className="rounded-md bg-accent px-10 py-4 font-heading text-lg uppercase tracking-wide text-navy transition hover:brightness-110"
            >
              Buy Now
            </a>
          </div>
        </section>

        {/* Order form */}
        <section id="grab-a-copy" className="container-site pb-24">
          <div className="rounded-3xl bg-muted px-6 py-16 sm:px-12">
            <h2 className="text-center text-4xl text-muted-foreground sm:text-5xl">
              Grab a <span className="text-brand-ink">Copy!</span>
            </h2>
            <div className="mt-12">
              <BookOrderForm bookSlug="fire-carriers" price="$25.00" />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
